import React from 'react';
import PropTypes from 'prop-types';

const Blockquote = ({ text }) => (
  <blockquote>{text}</blockquote>
);

Blockquote.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Blockquote;



// WEBPACK FOOTER //
// ./library/app/components/Content/Blockquote.js